import React, { Component } from "react";

import { withIntelligenceDateControls } from "./../../../shared/containers/containerIntelligenceDateControls";
import Icon from "./../../../shared/items/static/icon";
import TooltipWrapper from "./../../../shared/items/contols/tooltipWrapper";
import styles from "./intelligenceDateControl.module.scss";

class IntelligenceDateControl extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { isDataReady, onOpenIntelligenceDateControls, onCloseIntelligenceDateControls } = this.props;

   /*  if (isDataReady !== prevProps.isDataReady) {
      if (isDataReady) {
        onCloseIntelligenceDateControls();
      } else {
        onOpenIntelligenceDateControls();
      }
    } */
  }

  componentWillUnmount() {
    const { onOpenIntelligenceDateControls } = this.props;

    onOpenIntelligenceDateControls();
  }

  handleClick() {
    const { isIntelligenceDateControlsOpen, onOpenIntelligenceDateControls, onCloseIntelligenceDateControls } =
      this.props;

    if (isIntelligenceDateControlsOpen) {
      onCloseIntelligenceDateControls();
    } else {
      onOpenIntelligenceDateControls();
    }
  }

  render() {
    const { isIntelligenceDateControlsOpen, isDataReady } = this.props;

    return isDataReady ? (
      <TooltipWrapper title={isIntelligenceDateControlsOpen ? "Закрыть параметры" : "Открыть параметры"} position="top">
        <div
          className={
            !isIntelligenceDateControlsOpen ? styles.intelligenceDateControl : styles.intelligenceDateControl_opened
          }
          onClick={this.handleClick}
        >
          <Icon name="Subtract1" />
        </div>
      </TooltipWrapper>
    ) : null;
  }
}

export default withIntelligenceDateControls(IntelligenceDateControl);
